import { Button, DynamicContent, IconRow, SubmissionInfo } from 'components'

import { BsArrowRightSquare, BsCheckSquare } from 'react-icons/bs'

import { useTranslation } from 'react-i18next'
import useLocalStorageState from 'hooks/use-localstorage-state/use-localstorage-state'
import { SUBMISSIONS_NAME } from 'views/forms/form.constants'
import { Submission } from 'common.types'
import './MailInBallotSuccessScreen.scss'
import { useDynamicFormContent, useOneStop } from 'hooks'

export const MailInBallotSuccessScreen = () => {
  const FIND_VOTING_LOCATION_URL = '/find/return'
  const UPDATE_REGISTRATION_URL = '/register'
  const [submissions] = useLocalStorageState(
    SUBMISSIONS_NAME,
    {} as { [key: string]: any },
  )
  const { isOneStop, goToPlanToVote, updateRegistration } = useOneStop()
  const timestamps = Object.keys(submissions).map(Number)
  const mostRecentTimestamp = Math.max(...timestamps)
  const mostRecentValue: Submission =
    submissions[mostRecentTimestamp.toString()]
  const { serverResponse } = mostRecentValue.apiResponse
  const { applicationId, applicationDate } =
    serverResponse?.data?.data?.response
  const { formState } = mostRecentValue
  const { t } = useTranslation(undefined, {
    keyPrefix: `mailInBallotForm.successScreen`,
  })
  const buttonWrapperStyle = { marginTop: 30, marginBottom: 40 }
  const { formContent } = useDynamicFormContent()
  const overrideContent =
    formContent?.formOverrides?.['mail-in-ballot']?.success?.bottom
  const dates = formContent?.dates
  return (
    <div>
      <IconRow
        icon={BsCheckSquare}
        iconColor="green"
        text={t('success')}
      ></IconRow>
      <SubmissionInfo
        t={t}
        applicationDate={applicationDate}
        applicationId={applicationId}
        formState={formState}
      />
      <p
        style={{ marginLeft: 22, fontSize: 14 }}
        dangerouslySetInnerHTML={{ __html: t('disclosureTwo') }}
      />
      <IconRow
        icon={BsArrowRightSquare}
        iconColor="blue"
        text={t('return')}
      ></IconRow>
      {overrideContent ? (
        <DynamicContent data={overrideContent} />
      ) : (
        <>
          <p dangerouslySetInnerHTML={{ __html: t('note1') }} />
          <div style={buttonWrapperStyle}>
            <Button
              label={t('findAVotingLocation')}
              onClick={() => {
                if (isOneStop) {
                  goToPlanToVote()
                } else {
                  window.location.href = FIND_VOTING_LOCATION_URL
                }
              }}
              fullWidth={false}
            />
          </div>
          <p
            dangerouslySetInnerHTML={{
              __html: t('note3', { electionDay: dates?.electionDay }),
            }}
          ></p>
          <p>{t('note4', { electionDay: dates?.electionDay })}</p>
        </>
      )}
    </div>
  )
}
